/* global Swiper */
// *******************************************************************************
// 1.0 - Video text slider
// *******************************************************************************
const videoTextSliderElements = document.querySelectorAll('[data-slider="video-text-slider"]');

const videoTextSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 40,
  autoHeight: true,
  speed: 600,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

videoTextSliderElements.forEach((el) => {
  const videoTextSliderParent = el.closest('.sc-video-text');
  const arrowRight = videoTextSliderParent.querySelectorAll('.arrow-right')[0];
  const arrowLeft = videoTextSliderParent.querySelectorAll('.arrow-left')[0];
  const pagination = videoTextSliderParent.querySelector('.video-text-slider__pagination');

  videoTextSliderOptions.navigation.nextEl = arrowRight;
  videoTextSliderOptions.navigation.prevEl = arrowLeft;
  videoTextSliderOptions.pagination.el = pagination;

  // eslint-disable-next-line no-unused-vars
  const videoTextSlider = new Swiper(el, videoTextSliderOptions);
});
